import { isEmpty, filter, includes, escapeRegExp, get, reduce, xor, find, orderBy } from "lodash";
import moment from "moment";
import { guidGenerator, getTimeStamp } from "@Utils/functionality";
import { staticFilters } from "./Constants";

export const isEqualItems = (arr1, arr2) => {
	return arr1.length === arr2.length && xor(arr1, arr2).length === 0;
};

export const matchString = (data, value) => {
	const regExp = new RegExp(escapeRegExp(value), "i");
	const normalized = String(data)
		.normalize("NFD")
		.replace(/[\u0300-\u036f]/g, "");
	return regExp.test(normalized);
};

export const getChatsFilteredData = (
	data = [],
	platforms = [],
	groups = [],
	states = [],
	search = "",
	withAction = false,
	withTag = false
) => {
	if (isEmpty(data)) return [];
	if (
		isEmpty(platforms) &&
		isEmpty(groups) &&
		(isEmpty(states) || isEqualItems(states, staticFilters)) &&
		isEmpty(search) &&
		!withAction &&
		!withTag
	)
		return data;

	const filteredData = filter(data, (item) => {
		let isFiltered = true;
		let platformF = false;
		let groupF = false;
		let stateF = false;
		let searchF = false;
		let actionF = false;
		let tagF = false;

		if (withTag) {
			const tagsMatch = Array.isArray(item.tags)
				? item.tags.some((tag) => {
						return matchString(get(tag, "name", ""), "Plantilla");
				  })
				: false;
			if (tagsMatch) tagF = true;
			isFiltered = isFiltered && tagF;
			return isFiltered;
		}

		if (withAction) {
			if (!isEmpty(item.action)) actionF = true;
			isFiltered = isFiltered && actionF;
			return isFiltered;
		}

		if (!isEmpty(platforms)) {
			if (includes(platforms, get(item, "channel.label", ""))) platformF = true;
			isFiltered = isFiltered && platformF;
		}

		if (!isEmpty(groups)) {
			if (includes(groups, item.groupId)) groupF = true;
			isFiltered = isFiltered && groupF;
		}

		if (!isEmpty(states) && !isEqualItems(states, staticFilters)) {
			if (includes(states, item.state)) stateF = true;
			isFiltered = isFiltered && stateF;
		}

		if (!isEmpty(search)) {
			const tagsMatch = Array.isArray(item.tags)
				? item.tags.some((tag) => {
						return matchString(get(tag, "name", ""), search);
				  })
				: false;
			const closeDate = get(item, "closeDate", "");
			const createdDate = get(item, "createdDate", "");
			const formattedCloseDate = moment(closeDate).isValid() ? moment(closeDate, "YYYY-MM-DD").format("DD/MM/YYYY") : "";
			const formattedCreatedDate = moment(createdDate).isValid() ? moment(createdDate, "YYYY-MM-DD").format("DD/MM/YYYY") : "";
			if (
				matchString(get(item, "action", ""), search) ||
				matchString(get(item, "contact.name", ""), search) ||
				matchString(get(item, "contact.phone", ""), search) ||
				matchString(get(item, "contact.email", ""), search) ||
				matchString(get(item, "message.text", ""), search) ||
				matchString(get(item, "channel.label", ""), search) ||
				matchString(get(item, "channel.platform.name", ""), search) ||
				matchString(get(item, "user.fullName", ""), search) ||
				matchString(get(item, "group.name", ""), search) ||
				matchString(get(item, "group.name", ""), search) ||
				matchString(get(item, "closeState", ""), search) ||
				matchString(get(item, "origin", ""), search) ||
				matchString(get(item, "state", ""), search) ||
				matchString(formattedCloseDate, search) ||
				matchString(formattedCreatedDate, search) ||
				tagsMatch
			) {
				searchF = true;
			}
			isFiltered = isFiltered && searchF;
		}

		return isFiltered;
	});

	return filteredData;
};

export const getDummyMessage = (chatId) => {
	const message = {
		type: "Text",
		text: "",
		sentByAgent: true,
		chatId,
		id: guidGenerator(),
		channelMid: guidGenerator(),
		createdDate: getTimeStamp(),
		uri: "",
		reply: {},
	};
	return message;
};

export const getStateQuantity = (array, field) => {
	return reduce(
		array,
		(total, item) => {
			return item.state === field ? total + 1 : total;
		},
		0
	);
};

export const isWhatsappBlocked = (chat) => {
	const isWhatsapp = includes(["Whatsapp", "Whatsapp360"], get(chat, "channel.platform.name", ""));
	const lastClientMessage = find(orderBy(chat?.messages, "timestamp", "desc"), { sentByAgent: false });
	const isPast24Hrs = moment().diff(moment(lastClientMessage?.timestamp || 0), "hours") >= 24;
	if (isWhatsapp && isPast24Hrs) return true;
	return false;
};
